// The card rhythm from the apps: 24px radius (the apps' lg card corner since
// 2026-09-28), 20px inner padding (apps' space.card), a 1px
// hairline, and a shadow at 0.04 opacity, 10px blur, 4px down. One definition so
// twenty sections cannot invent twenty near identical cards.
//
// On navy, the hairline and shadow are invisible, so the card takes the navy
// surface colour and a white edge at 10% instead.

//
// `as` lets a list item or a figure wear the card without an extra wrapper.
// `pad` is 'md' (20px, the apps' card interior) or 'lg' (28px to 40px, a
// reading surface such as a legal document).
const PADS = { none: '', md: 'p-5 md:p-6', lg: 'p-7 md:p-10' }

export default function Card({ as: Tag = 'div', on = 'light', pad = 'md', className = '', children, ...rest }) {
  const skin = on === 'navy'
    ? 'bg-navy-surface border-white/10'
    : 'bg-surface border-hairline shadow-[0_4px_10px_rgba(12,24,41,0.04)]'
  return (
    <Tag className={`rounded-card border ${PADS[pad]} ${skin} ${className}`} {...rest}>
      {children}
    </Tag>
  )
}
